import React from 'react';

import './drawer.scss';

import Loader from '../../components/loader';
import CarouselCountries from '../../components/carousel/carousel.countries';
// import CarouselStates from 'components/carousel/carousel.states';
import Scroller from '../../components/scroller';
import LocalizedComponent from '../../components/localizedComponent';
import observeRootStore from '../../components/hoc/observeRootStore';
import * as constants from '../../appConstants';

export class Drawer extends LocalizedComponent {
    render() {
        const { rootStore } = this.props;
        const activeMap = rootStore.uiStore.activeMap;
        return (
            <div className="site-drawer">
                {activeMap === constants.NORTH_AMERICA ?
                    <CarouselCountries /> :
                    <Scroller country={rootStore.opsMapCountries[activeMap]}/>
                }

                {rootStore.uiStore.isLoading && <Loader />}
            </div>
        );
    }
}

export default observeRootStore(Drawer);
